/* eslint-disable react/no-multi-comp */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { GroupHealthInsurance as SectionKey } from 'Consts/Questionnaire';
import { section } from 'Consts/Queries';
import { QueryVal } from 'Helpers/Query';
import CircleWithCount from 'Icons/CircleWithCount';
import { Box, Typography } from '@material-ui/core';
import LabeledVerticalExpander from '../UI/LabeledVerticalExpander';
import BoolInput from '../Fields/BoolInput';
import CurrencyInput from '../Fields/CurrencyInput';
import FieldList from '../Fields/FieldList';
import RadioInput from '../Fields/RadioInput';
import TextInput from '../Fields/TextInput';
import TextareaInput from '../Fields/TextareaInput';
import Section from '../Section';

class HealthSavingsAccountList extends Component {
  constructor(props) {
    super(props);

    this.state = {
      healthSavingsAccountsInstitution: '',
    };

    this.onChange = this.onChange.bind(this);
    this.getAccountName = this.getAccountName.bind(this);
  }

  onChange(name, value) {
    this.setState({ [name]: value });
  }

  getAccountName() {
    const { healthSavingsAccountsInstitution } = this.state;
    return healthSavingsAccountsInstitution || 'New account';
  }

  render() {
    const {
      getAccountName,
      onChange,
      props: { id, children: removeButton, expanded },
    } = this;
    return (
      <LabeledVerticalExpander
        transitionSpeed={0.15}
        title={getAccountName()}
        removeButton={removeButton}
        firstElementFocusable
        expanded={expanded}
      >
        <BoolInput
          label="Is this account eligible for investment?"
          name={`healthSavingsAccountsEligibleForInvestment.${id}`}
          answerKey="healthSavingsAccountsEligibleForInvestment"
        />
        <TextInput
          placeholder="Financial institution"
          name={`healthSavingsAccountsInstitution.${id}`}
          answerKey="healthSavingsAccountsInstitution"
          onChange={(name, value) => onChange('healthSavingsAccountsInstitution', value)
          }
        />
        <TextInput
          placeholder="HSA Name"
          name={`healthSavingsAccountsName.${id}`}
          answerKey="healthSavingsAccountsName"
          onChange={(name, value) => onChange('healthSavingsAccountsName', value)
          }
        />
        <CurrencyInput
          placeholder="Balance"
          name={`healthSavingsAccountsBalance.${id}`}
          answerKey="healthSavingsAccountsBalance"
        />
        <CurrencyInput
          placeholder="Annual contributions"
          name={`healthSavingsAccountsAnnualContribution.${id}`}
          answerKey="healthSavingsAccountsAnnualContribution"
        />
      </LabeledVerticalExpander>
    );
  }
}

HealthSavingsAccountList.propTypes = {
  id: PropTypes.number.isRequired,
  children: PropTypes.node.isRequired,
  expanded: PropTypes.bool,
};

HealthSavingsAccountList.defaultProps = {
  expanded: false,
};

class FlexibleSpendingAccountList extends Component {
  constructor(props) {
    super(props);

    this.state = {
      flexibleSpendingAccountsInstitution: '',
    };

    this.onChange = this.onChange.bind(this);
    this.getAccountName = this.getAccountName.bind(this);
  }

  onChange(name, value) {
    this.setState({ [name]: value });
  }

  getAccountName() {
    const { flexibleSpendingAccountsInstitution } = this.state;
    return flexibleSpendingAccountsInstitution || 'New account';
  }

  render() {
    const {
      getAccountName,
      onChange,
      props: { id, children: removeButton, expanded },
    } = this;
    return (
      <LabeledVerticalExpander
        transitionSpeed={0.15}
        title={getAccountName()}
        removeButton={removeButton}
        firstElementFocusable
        expanded={expanded}
      >
        <BoolInput
          label="Is this account eligible for investment?"
          name={`flexibleSpendingAccountsEligibleForInvestment.${id}`}
          answerKey="flexibleSpendingAccountsEligibleForInvestment"
        />
        <TextInput
          placeholder="Financial institution"
          name={`flexibleSpendingAccountsInstitution.${id}`}
          answerKey="flexibleSpendingAccountsInstitution"
          onChange={(name, value) => onChange('flexibleSpendingAccountsInstitution', value)
          }
        />
        <CurrencyInput
          placeholder="Balance"
          name={`flexibleSpendingAccountsBalance.${id}`}
          answerKey="flexibleSpendingAccountsBalance"
        />
        <CurrencyInput
          placeholder="Annual contributions"
          name={`flexibleSpendingAccountsAnnualContribution.${id}`}
          answerKey="flexibleSpendingAccountsAnnualContribution"
        />
        <RadioInput
          label="Account type"
          name={`flexibleSpendingAccountsType.${id}`}
          answerKey="flexibleSpendingAccountsType"
          options={[
            {
              id: 'healthcare',
              text: 'Healthcare FSA',
            },
            {
              id: 'dependent',
              text: 'Dependent care FSA',
            },
          ]}
        />
      </LabeledVerticalExpander>
    );
  }
}

FlexibleSpendingAccountList.propTypes = {
  id: PropTypes.number.isRequired,
  children: PropTypes.node.isRequired,
  expanded: PropTypes.bool,
};

FlexibleSpendingAccountList.defaultProps = {
  expanded: false,
};

const GroupHealthInsurance = ({ id }) => {
  const [fsaCount, setFSACount] = React.useState(0);

  return (
    <Section
      CountComponent={<Box className="expander-header-multi-count expander-header-left"><Typography>FSA</Typography><CircleWithCount count={fsaCount} className="expander-header-count" /></Box>}
      transitionSpeed={0.25}
      height={400}
      title="Group Health Insurance"
      sectionKey={SectionKey}
      expanded={QueryVal(section) === SectionKey}
    >
      <TextareaInput
        placeholder="Group health insurance details"
        name={`groupHealthInsuranceDetails.${id}`}
        answerKey="groupHealthInsuranceDetails"
      />
      <FieldList
        onCountUpdate={setFSACount}
        id="fsa"
        label="Account - FSA"
        addLabel="Add an account"
        keyPrefix="flexibleSpendingAccounts"
        Of={FlexibleSpendingAccountList}
      />
    </Section>
  );
};

GroupHealthInsurance.propTypes = {
  id: PropTypes.number.isRequired,
};

export default GroupHealthInsurance;
